import type { DataResponse } from '../types';

export const handleEmptyResponse = <T>(response: DataResponse<T>): T => {
  const { data: responseContent = [] as T } = response;

  return responseContent;
};
